<template>
  <div class="option-toggle">
    <h5 v-if="getT && theOption.title === 'Length'">{{ theOption.title }}</h5>
    <h5 v-if="getT && theOption.title === 'Width'">{{ theOption.title }}</h5>
    <h5 v-if="getT && theOption.title === 'Depth'">{{ theOption.title }}</h5>
    <div class="toggle-wrap">
      <button
        v-for="choice in modelOption.choices"
        v-bind:key="choice.id"
        class="toggle"
        :class="{
          active: theOption.value == choice.id,
          disabled: isSizeBtnDisabled(optionId, choice.id),
        }"
        v-on:click="setToggle(choice.id)"
      >
        <div v-if="suffix && wrappableSuffix(suffix)">
          <div class="wrap-top">{{ choice.measurement }}</div>
          <div class="wrap-bottom">{{ suffix }}</div>
        </div>
        <div v-else>
          <span>{{ choice.measurement }}</span><span class="uom">{{ suffix }}</span>
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OptionToggle',
  props: ['optionId', 'suffix'],
  methods: {
    // conditional logic preventing some combinations of selections
    isSizeBtnDisabled(dimension, choice) {
      // dimension: len, width, or depth
      // choice: ID for one of the choices for the dimension

      /* 
        Certain size combinations are disallowed. 
        If 16 foot length or width is selected for a modular pool, need to hide the 54 inch depth option.
      */

      // if user has selected 16 foot for length or width
      if (
        this.$store.state.optionSelections['len'].value == '16' ||
        this.$store.state.optionSelections['width'].value == '16'
      ) {
        // if method is being called for depth choice of 54 inches
        if (dimension == 'depth' && choice == '54') {
          // then this button is disabled
          return true;
        }
      }

      // if user has selected depth of 54 inches
      if (this.$store.state.optionSelections['depth'].value == '54') {
        // if method is being called for dimension of length or width
        if (dimension == 'len' || dimension == 'width') {
          // if method is being called for choice of 16 feet
          if (choice == '16') {
            // then this button is disabled
            return true;
          }
        }
      }

      // otherwise, not disabled
      return false;
    },
    wrappableSuffix(value) {
      return value !== "'" && value !== '"';
    },
    setToggle(value) {
      // check for conflicts with other size dimension selections
      if (this.isSizeBtnDisabled(this.optionId, value)) {
        // do nothing
        return;
      }

      this.$store.dispatch('updateOptionSelections', {
        name: this.theOption.key,
        value: value,
      });
      // Update callback
      this.$emit('update', value);

      this.$emit('measurementClick', value);
    },
  },
  computed: {
    ...mapGetters(['getT', 'currPool']),
    modelOption: function () {
      return this.currPool.options[this.optionId];
    },
    theOption: function () {
      return this.$store.state.optionSelections[this.optionId];
    },
  },
};
</script>
<style scoped lang="scss">
.wrap-cont {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.wrap-top {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  line-height: 100%;
}
.wrap-bottom {
  margin-top: 0px !important;
  padding-top: 0px !important;
  line-height: 100%;
}
.option-toggle {
  padding: 0.5em 0.7em 0.5em 1em;
  min-height: 4.5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid $deep-slate;
  h5 {
    min-width: 5em;
    color: white;
  }
  .toggle-wrap {
    max-width: 20em;
    padding-left: 0.5rem;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    button.toggle {
      text-transform: lowercase;
      font-family: 'Europa Bold', sans-serif;
      padding: 0.8rem 1rem;
      margin: 0.2rem;
      background-color: $navy;
      border: none;
      cursor: default;
      &.active {
        background-color: $teal;
      }
      &.disabled {
        color: $deep-slate;
        cursor: default !important;
      }
      @media #{$desktop} {
        transition-duration: 200ms;
        &:not(.active):not(.disabled):hover {
          background-color: lighten($navy, 4%);
        }
      }
    }
  }
  &.secondary {
    padding: 0.5rem 1rem;
    border-bottom: 1px solid $deep-slate;
    .toggle-wrap button.toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 3em;
      max-width: 3em;
      min-height: 3em;
      padding: 0;
      background-color: $navy;
      &.active {
        background-color: $teal;
      }
    }
  }
}
.uom {
  opacity: 0.7;
}
</style>
